import { FormFieldWrapper } from '@/components/forms/FormFieldWrapper';
import { FormField } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Control } from 'react-hook-form';
import type { FormAData } from '../types/formA.types';

interface BeneficialOwnerTypeSelectorProps {
  control: Control<FormAData>;
  tForms: (key: string) => string;
}

/**
 * BeneficialOwnerTypeSelector component
 * Radio group for selecting the beneficial owner type
 */
export const BeneficialOwnerTypeSelector = ({
  control,
  tForms,
}: BeneficialOwnerTypeSelectorProps) => {
  return (
    <div className='space-y-6'>
      <div className='flex items-center gap-2 mb-4'>
        <h3 className='text-lg font-semibold'>
          {tForms('kyc.beneficialOwner.title')}
        </h3>
      </div>

      <div className='space-y-4'>
        <FormField
          control={control}
          name='beneficialOwnerType'
          render={({ field, fieldState }) => (
            <FormFieldWrapper
              label={tForms('kyc.beneficialOwner.declarationLabel')}
              name='beneficialOwnerType'
              required
              error={fieldState.error?.message}
              isGroupLabel={true}
            >
              <RadioGroup
                value={field.value}
                onValueChange={field.onChange}
                className='space-y-3'
              >
                <div className='flex items-center space-x-2'>
                  <RadioGroupItem value='sole' id='sole' />
                  <label
                    htmlFor='sole'
                    className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
                  >
                    {tForms('kyc.beneficialOwner.soleOwnerLabel')}
                  </label>
                </div>
                <div className='flex items-center space-x-2'>
                  <RadioGroupItem value='others' id='others' />
                  <label
                    htmlFor='others'
                    className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
                  >
                    {tForms('kyc.beneficialOwner.othersOwnerLabel')}
                  </label>
                </div>
              </RadioGroup>
            </FormFieldWrapper>
          )}
        />
      </div>
    </div>
  );
};
